import React, { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';

import { apiFetch } from '../shared/api/apiFetch';

const uiConfig = require('../uiConfig');
const { getMessageForFetchError } = require('../shared/utils/apiError');

function VerifyEmail() {
  const [searchParams] = useSearchParams();
  const userId = (searchParams.get('u') || '').trim();
  const code = (searchParams.get('c') || '').trim();
  const [status, setStatus] = useState('loading'); // 'loading' | 'success' | 'error'
  const [message, setMessage] = useState('');

  const serverUrl = uiConfig.serverInfo?.serverUrl || '';

  useEffect(() => {
    let cancelled = false;

    async function run() {
      if (!userId || !code) {
        setStatus('error');
        setMessage('Invalid link. Missing verification details.');
        return;
      }
      if (!serverUrl) {
        setStatus('error');
        setMessage('Configuration error. Please try again later.');
        return;
      }
      try {
        const res = await apiFetch(serverUrl + '/verifyEmailByLink', {
          method: 'POST',
          body: JSON.stringify({ user_id: userId, code }),
        });
        const data = await res.json().catch(() => ({}));
        if (cancelled) return;
        if (res.ok && data && data.success) {
          setStatus('success');
          setMessage(data.message || 'Email verified successfully.');
          return;
        }
        setStatus('error');
        setMessage((data && data.message) || 'Unable to verify email. The link may be invalid or already used.');
      } catch (err) {
        if (cancelled) return;
        setStatus('error');
        setMessage(getMessageForFetchError(err));
      }
    }

    run();
    return () => {
      cancelled = true;
    };
  }, [userId, code, serverUrl]);

  return (
    <div style={{ minHeight: '100%', background: '#f5f5f5' }}>
      <header className="page-hero">
        <h1>Verify email</h1>
      </header>
      <div className="page-container" style={{ flex: 1, minHeight: 0 }}>
        <div style={{ paddingBottom: 28, maxWidth: 480 }}>
          {status === 'loading' && (
            <p style={{ color: '#666' }} aria-live="polite">Verifying your email…</p>
          )}
          {status === 'success' && (
            <p style={{ color: '#0f5132', marginBottom: 16 }} aria-live="polite">{message}</p>
          )}
          {status === 'error' && (
            <p style={{ color: '#842029', marginBottom: 16 }} aria-live="polite">{message}</p>
          )}
          <p style={{ fontSize: 14, color: '#6c757d' }}>
            You can close this page or go to <Link to="/Login">Login</Link>.
          </p>
        </div>
      </div>
    </div>
  );
}

export default VerifyEmail;
